module.exports = __webpack_public_path__ + "static/media/login.58e997e1.jpg";